import {customProcessor, docCreditCard, docEwalet} from "mock-data/mock-api/gateways";
import store from "../../state/store"
import {theme} from "mock-data/mock-api/test-theme";
import {profile} from "mock-data/mock-api/test-get-profile";
import {gateways, obGateways, apmGateways} from "mock-data/mock-api/test-get-gateways";
import {result} from "mock-data/mock-api/test-pay-with-gateway";
import {save} from "mock-data/mock-api/test-save-data";
import {removeTransactions, transactions} from "mock-data/mock-api/get-transactions";
import {options, failedOptions} from "mock-data/mock-api/test-get-dinamic-options";
import {callbackResult} from "mock-data/mock-api/callback-result";
import {partialApprovedResult} from "mock-data/mock-api/test-partial-approve-pay";
import {getCurrentGateway} from "mock-data/mock-api/gateway-details";
import {getProcessingGatewaysList} from "mock-data/mock-api/get-processing-gateway-list";
import {payWithManageRetryRequest} from "mock-data/mock-api/pay-with-manage-retry-request";
import {mockComputeData} from "mock-data/mock-api/test-get-compute-data";
import {mockInitialDataPanoramic, mockInitialDataAmountFirst} from "mock-data/mock-api/test-get-initial-data";
import {availableObtMethods} from "mock-data/mock-api/test-get-available-obt-methods";
import {mockCustomerCurrenciesTransactionPromocodesData} from "mock-data/mock-api/test-get-customer-currencies-transaction-promocodes-data";
import {mockCustomerLastTransactionPromocodesData} from "mock-data/mock-api/test-get-customer-last-transaction-promocodes-data";
import {mockSessionTransaction} from "mock-data/mock-api/test-get-session-transaction";
import {mockTransaction} from "mock-data/mock-api/test-get-transaction";
import {mockOBRecoveryTransaction, mockAPMRecoveryTransaction} from "mock-data/mock-api/test-get-session-transaction";
import {payment_method_groups} from "mock-data/mock-api/test-payment-method-groups";
import {mockPaymentMethodGroupsPanoramic} from "mock-data/mock-api/test-payment-method-groups-panoramic";
import {getPaymentMethodDetails} from "mock-data/mock-api/test-payment-method-details";
import {getPaymentMethodDetailsPanoramic} from "mock-data/mock-api/test-payment-method-details-panoramic";
import {withdrawal_requests} from "mock-data/mock-api/test-withdrawal-request";
import {initMockPraxisGate} from "mock-data/mock-pci/mock-praxis-gate";
import {mockManageTemplateSuccess} from "mock-data/mock-api/test-manage-template";

/**
 * Recovery scenario toggle for local testing.
 * Change this value to switch between scenarios:
 *   'normal'  — Default declined transaction with retry_settings (insufficient funds)
 *   'ob'      — OB decline recovery (ob_decline_recovery: true)
 *   'apm'     — APM decline recovery (retry_with_apm: true)
 */
const RECOVERY_SCENARIO = 'normal';
const activeSessionTransaction =
    RECOVERY_SCENARIO === 'ob' ? mockOBRecoveryTransaction :
    RECOVERY_SCENARIO === 'apm' ? mockAPMRecoveryTransaction :
    mockSessionTransaction;

const mapSessionTransactionToPayWithGatewayResponse = () => {
    const tx = activeSessionTransaction?.data?.transaction || {};
    const { retry_settings, ...txWithoutRetrySettings } = tx || {};

    return {
        ...result,
        error_message: tx?.error_message ?? result?.error_message,
        new_attempt: tx?.new_attempt ?? result?.new_attempt,
        transaction: {
            ...result?.transaction,
            ...txWithoutRetrySettings,
            retry_settings: retry_settings,
        },
        submit_action: tx?.submit_action ?? result?.submit_action,
        submit_name: tx?.submit_name ?? result?.submit_name,
        ob_decline_recovery: tx?.ob_decline_recovery ?? result?.ob_decline_recovery,
        retry_with_apm: tx?.retry_with_apm ?? result?.retry_with_apm,
        show_reject_reason: tx?.show_reject_reason ?? result?.show_reject_reason,
        transaction_type: tx?.transaction_type ?? result?.transaction_type,
        status: (tx?.ob_decline_recovery || tx?.retry_with_apm) ? 2 : result.status,
    };
};

/**
 * Startup injection: seed resultOfPay for recovery scenarios so the recovery
 * UI shows immediately on load without needing a real payment first.
 * Waits for profile data to be available, then dispatches.
 */
if (RECOVERY_SCENARIO !== 'normal') {
    const waitForProfileAndInject = () => {
        const state = store.getState();
        const profileReady = state?.profileInfo?.transaction_type;
        if (profileReady) {
            const recoveryPayload = mapSessionTransactionToPayWithGatewayResponse();
            store.dispatch({ type: 'CREATE_RESULT_OF_PAY', payload: recoveryPayload });
            console.log('[mock] Injected recovery resultOfPay for scenario:', RECOVERY_SCENARIO, recoveryPayload);
        } else {
            setTimeout(waitForProfileAndInject, 200);
        }
    };
    setTimeout(waitForProfileAndInject, 500);
}

export const getTestData = (key, params={},useSettings=false) => {
    let {option_id, ob_decline_recovery, retry_with_apm, currency } = params || {};
    let data={};
    if(useSettings) changeData();
    const layout = store.getState()?.initTheme?.theme_editor_settings?.customization_settings?.layout;
    
    if(key === "get-transactions") data = transactions;
    if(key === "delete-transaction") data = removeTransactions;
    if(key === "get-customer-data") data = profile;
    if(key === "callback") data = callbackResult;
    if(key === "get-gateway-details") data = getCurrentGateway[option_id];
    if(key.includes("get-gateway-list") || key.includes("get-payment-method-list")) data = ob_decline_recovery ? obGateways : retry_with_apm ? apmGateways : gateways;
    if(key === "pay-with-gateway") data = layout === 'amount-first' ? mapSessionTransactionToPayWithGatewayResponse() : result;
    if(key === "get-dynamic-options") data = params?.dynamic_field_name === "QB" ? failedOptions : options;
    if(key === "save-data") data = save;
    if(key === "get-asset-data") data = theme;
    if(key === "partial-approve") data = partialApprovedResult;
    if(key === "get-processing-gateway-list") data = getProcessingGatewaysList;
    if(key === "manage-retry-request") data = payWithManageRetryRequest;
    if(key === 'get_compute_data') data = mockComputeData;
    if(key === 'get_initial_data_panoramic') data = mockInitialDataPanoramic;
    if(key === 'get_initial_data_amount_first') data = mockInitialDataAmountFirst;
    if(key === 'get_customer_currencies_transaction_promocodes_data') data = mockCustomerCurrenciesTransactionPromocodesData;
    if(key === 'get_customer_last_transaction_promocodes_data') data = mockCustomerLastTransactionPromocodesData;
    if(key === 'get_transaction') data = mockTransaction;
    if(key === 'get_session_transaction') data = activeSessionTransaction;
    if(key === 'get_payment_method_groups') data = payment_method_groups(currency);
    if(key === 'get_payment_method_groups_panoramic') data = mockPaymentMethodGroupsPanoramic;
    if(key === 'get-available-obt-methods') data = availableObtMethods;
    if(key === 'get_withdrawal_requests') data = withdrawal_requests;
    if(key === 'get_gateway_details') {
        const { option_id, option_type } = params || {};
        data = getPaymentMethodDetails(option_id, option_type);
    }
    if(key === 'get_gateway_details_panoramic') {
        const { option_id, option_type } = params || {};
        data = {data: getPaymentMethodDetailsPanoramic(option_id, option_type)}
    }
    if (key === 'manage-template') data = mockManageTemplateSuccess; // Can return mockManageTemplateFail
    return data;
};

const changeData = () => {
    const {data_doc=""} = store.getState().location;
    // const data_doc = "MCwzMDAwLDEwMCwwLDAsMCwwLGRlLURFLDAsLDAsMCwwLGNsYXNzaWMsMCwwLDA=";
    const settings = window.atob(data_doc).split(",");

    const currentGateway = settings[16] === "0"? docCreditCard : settings[16] === "1"? docEwalet : customProcessor;
    const {payment_information:{currency_list={}}={}} = currentGateway;
    profile.base_amount = settings[2];
    profile.customer.balance = settings[1];
    profile.transaction_type = settings[15] === "0"? 'pay-in' : "pay-out";
    profile.customer.phone = settings[4] === "1"? "" : "0990938373";
    profile.session_type = settings[10] === "0"? "cashier" : "vt";
    if(settings[0] === "1") currentGateway.additional_fields = null;
    result.is_iframe = settings[6];
    result.redirect_url = settings[9];
    result.transaction.status = settings[17];
    currentGateway.payout_condition = settings[8] === "1"? "same_account" : null;
    currentGateway.skip_customer_details = settings[11];
    if(settings[12] === "1") currentGateway.templates = [];
    if(settings[3] === "1") delete currency_list[profile.base_currency];
    if(settings[3] === "2") {delete currency_list[profile.base_currency]; delete currency_list["EUR"]}
    if(settings[5] === "1") Object.keys(currency_list).map(el => {
        delete currency_list[el].min_amount;
        delete currency_list[el].max_amount;
    });
    gateways.gateways=[currentGateway];
    theme.locale=settings[7];
    theme.theme=settings[13];
};
export const graphqlMockRequest = async (query = [], delay = 0, mockName, params={}) => {
    return new Promise((resolve) => {
        setTimeout(() => {
            try {
                let data = {}
                const cashier = getTestData(mockName, params);
                query.forEach((el) => {
                    if(cashier[el]) {
                        data = {...data, [el]: cashier[el]}
                    }
                })
                const response = query?.length > 0 ? data : cashier;
                resolve(response);
            }
            catch (error) {
                console.error('graphqlMockRequest error', error);
                resolve({});
            }
        }, delay)
    })
}

export { initMockPraxisGate };
